export const MALE = 'MALE';
export const FEMALE = 'FEMALE';
export const MALE_TITLES = [{ code: 'Mr', description: 'Mr', displayOrder: 1 }];
export const FEMALE_TITLES = [
    { code: 'Mrs', description: 'Mrs', displayOrder: 2 },
    { code: 'Miss', description: 'Miss', displayOrder: 3 },
];
export const ALL_TITLES = [...MALE_TITLES, ...FEMALE_TITLES];

export const PRODUCT_DETAIL_URL = '/personal/gi-claims/';
export const ALLSURE_HOME_CLAIM_URL_PREFIX = '/personal/claims/allsure-homeowner-claim';
export const ALLSURE_CONTENT_CLAIM_URL_PREFIX = '/personal/claims/allsure-content-claim';
export const APP_NOT_INITIATED = 'APP_NOT_INITIATED';
export const ALLSURE_CLAIM_NAME={
    HOME_CLAIM:'Allsure Homeowners Claim',
    CONTENT_CLAIM:'Allsure Home Contents Claim'
}
export const PAGES = [
    {
        URL: `${ALLSURE_HOME_CLAIM_URL_PREFIX}/category/`,
        URL_PART: 'category',
        TITLE: 'Category Type',
    },
    {
        URL: `${ALLSURE_HOME_CLAIM_URL_PREFIX}/basic-details/`,
        URL_PART: 'basic-details',
        TITLE: 'Basic Details',
    },
    {
        URL: `${ALLSURE_HOME_CLAIM_URL_PREFIX}/incident-details/`,
        URL_PART: 'incident-details',
        TITLE: 'Incident Details',
    },
    {
        URL: `${ALLSURE_HOME_CLAIM_URL_PREFIX}/upload-documents/`,
        URL_PART: 'upload-documents',
        TITLE: 'Upload Documents',
    },
    {
        URL: `${ALLSURE_HOME_CLAIM_URL_PREFIX}/confirmation/`,
        URL_PART: 'confirmation',
        TITLE: 'Confirmation Page',
    },
    {
        URL: `${ALLSURE_HOME_CLAIM_URL_PREFIX}/successful/`,
        URL_PART: 'successful',
        TITLE: 'Success Page',
    },
];
export const ALLSURE_CONTENT_PAGES = [
    {
        URL: `${ALLSURE_CONTENT_CLAIM_URL_PREFIX}/category/`,
        URL_PART: 'category',
        TITLE: 'Category Type',
    },
    {
        URL: `${ALLSURE_CONTENT_CLAIM_URL_PREFIX}/basic-details/`,
        URL_PART: 'basic-details',
        TITLE: 'Basic Details',
    },
    {
        URL: `${ALLSURE_CONTENT_CLAIM_URL_PREFIX}/incident-details/`,
        URL_PART: 'incident-details',
        TITLE: 'Incident Details',
    },
    {
        URL: `${ALLSURE_CONTENT_CLAIM_URL_PREFIX}/upload-documents/`,
        URL_PART: 'upload-documents',
        TITLE: 'Upload Documents',
    },
    {
        URL: `${ALLSURE_CONTENT_CLAIM_URL_PREFIX}/confirmation/`,
        URL_PART: 'confirmation',
        TITLE: 'Confirmation Page',
    },
    {
        URL: `${ALLSURE_CONTENT_CLAIM_URL_PREFIX}/successful/`,
        URL_PART: 'successful',
        TITLE: 'Success Page',
    },
];

export const PAGE_URLS = {
    QUOTE: PRODUCT_DETAIL_URL,
    CATEGORY: `${ALLSURE_HOME_CLAIM_URL_PREFIX}/${PAGES[0].URL_PART}`,
    BASIC_DETAILS: `${ALLSURE_HOME_CLAIM_URL_PREFIX}/${PAGES[1].URL_PART}`,
    INCIDENT_DEATAILS: `${ALLSURE_HOME_CLAIM_URL_PREFIX}/${PAGES[2].URL_PART}`,
    UPLOAD_DOCUMENTS: `${ALLSURE_HOME_CLAIM_URL_PREFIX}/${PAGES[3].URL_PART}`,
    CONFIRMATION: `${ALLSURE_HOME_CLAIM_URL_PREFIX}/${PAGES[4].URL_PART}`,
    SUCCESS: `${ALLSURE_HOME_CLAIM_URL_PREFIX}/${PAGES[5].URL_PART}`,
};

export const PAGE_INDICES = {
    CATEGORY: 0,
    BASIC_DETAILS: 1,
    INCIDENT_DEATAILS: 2,
    UPLOAD_DOCUMENTS: 3,
    CONFIRMATION: 4,
    SUCCESS: 5,
};

export const fileTypeIcons = {
    jpg: 'https://eu-images.contentstack.com/v3/assets/blta37b98ee289f937f/blt4d93eb23d94dba05/666aa8e589f54a66e3d94fef/File_Icon_JPG.svg',
    jpeg: 'https://eu-images.contentstack.com/v3/assets/blta37b98ee289f937f/blt8abddfa86d652fdc/666aa8e592485f825f3e5f36/File_Icon_JPEG.svg',
    pdf: 'https://eu-images.contentstack.com/v3/assets/blta37b98ee289f937f/bltca067e85c16b9ea3/666aa8e524c3b38251c8b595/File_Icon_PDF.svg',
    tif: 'https://eu-images.contentstack.com/v3/assets/blta37b98ee289f937f/bltce7d760991642227/666aa8e5f826a314d4359512/File_Icon_TIF.svg',
    tiff: 'https://eu-images.contentstack.com/v3/assets/blta37b98ee289f937f/bltdc26cb95c99cbadc/666aa8e589f54a8f9dd94ff3/File_Icon_TIFF.svg',
    png: 'https://eu-images.contentstack.com/v3/assets/blta37b98ee289f937f/bltee48f5e3c2e1d53a/666aa8e5372321a807e91b34/File_Icon_PNG.svg',
};

const SIZE_2_MB = 2097152;
const SIZE_1_kb = 1024;

export const UPLOAD_PAGE_CONFIG = {
    MIN_INPUT_SIZE: SIZE_1_kb,
    MIN_INPUT_SIZE_NAME: '1 kb',
    MAX_INPUT_SIZE: SIZE_2_MB,
    MAX_INPUT_SIZE_NAME: '2 mb',
    VALID_UPLOAD_TYPES: [
        { FORMAT: 'image/jpeg', FORMAT_NAME: 'JPG' },
        { FORMAT: 'image/png', FORMAT_NAME: 'PNG' },
        { FORMAT: 'application/pdf', FORMAT_NAME: 'PDF' },
    ],
};

export const RADIO_OPTION = {
    YES: 'Yes',
    NO: 'No',
    NA: 'Not Applicable'
};

export const PROGRESS_BAR_STEPS = [
    {
        title: 'Basic Details',
        key: 'BASIC_DETAILS',
        isActive: false,
        isCompleted: false,
    },
    {
        title: 'Incident Details',
        key: 'INCIDENT_DEATAILS',
        isActive: false,
        isCompleted: false,
    },
    {
        title: 'Upload Documents',
        key: 'UPLOAD_DOCUMENTS',
        isActive: false,
        isCompleted: false,
    },
    {
        title: 'Confirmation',
        key: 'CONFIRMATION',
        isActive: false,
        isCompleted: false,
    },
];

export const AHOC_MANDATORY_DOCUMENTS = ['certifiedCopyOfId','policeReport','repairQuotes','technicalReport', 'fireReport']
export const AHOC_REQUIRED_DOCUMENTS = {
  certifiedCopyOfId: {
        key: 'certifiedCopyOfId',
        title: 'Certified copy of Omang/ID card or passport',
        caption: 'Not more than 5 years old',
        requiredCategory: [" "],
    },
   
    // fireBrigadeReport: {
    //     key: 'fireBrigadeReport',
    //     title: 'Fire brigade report',
    //     caption: 'Fire brigade report',
    //     requiredCategory: ['Fire'],
    // },
    policeReport: {
        key: 'policeReport',
        title: 'Police report',
        caption: 'Police report detailing the incident. For fire, theft & malicious damage',
        requiredCategory: ['Fire', 'Malicious', 'Theft'],
    },
    repairQuotes: {
        key: 'repairQuotes',
        title: 'Two repair or replacement quotes',
        caption: 'For the damaged property, including itemized costs.',
        requiredCategory: [' '],
    },
    technicalReport: {
        key: 'technicalReport',
        title: 'Technical report  (Optional)',
        caption: 'For damaged equipment',
        requiredCategory: [' '],
    },
    fireReport: {
        key: 'fireReport',
        title: 'Fire report (Optional)',
        caption: 'For fire claims',
        requiredCategory: [' '],
    },
    additionalDocument: {
      key: 'additionalDocument',
      title: 'Additional document',
      caption: 'Additional document',
      requiredCategory: [" "],
  },
};

export const BASIC_DETAILS_LABELS = {
    policyNumber: 'Policy number *',
    fullName: 'Full name *',
    mobileNumber: 'Cellphone number *',
    email: 'Email address *',
};

export const INCIDENT_DEATAILS_LABELS = {
    dateOfIncident: 'Date of incident *',
    reasonForDelay: 'Reason for late notification *',
    timeOfIncident: 'Time of incident *',
    addressOrLocation: 'Address or location of the incident *',
    insuredValue: 'Value of property insured *',
    dateValued: 'Date valued (Optional)',
    lossOccurredDescription: 'Describe how the loss occurred *',
    occupiedAtTimeOfLoss: 'Were the premises occupied at time of loss? *',
    burglarAlarmActivated: 'Was the burglar alarm activated? *',
    damageOccuredPreviously: 'Have you previously suffered loss/damage ? *',
    damageOccuredPreviouslyDescription: 'If yes, provide detailed description *',
    insurerName: 'Name of insurer *',
    thirdPartyReponsilbile: 'Is a third party responsible for the loss or damage? *',
    thirdPartyName: 'Full name of third party (Optional)',
    thirdPartyContactNumber: 'Third party cellphone number  (Optional)',
    thirdPartyAddress: 'Third party address (Optional)',
    thirdPartyEmail: 'Third party email address (Optional)',
    personTobeKeptInformed: 'Alternate person to be kept informed of the claim process (Optional)',
    personsFullName: 'Contact person’s full name *',
    personsContact: 'Contact person’s cellphone number *',
    personsEmail: 'Contact person’s email address (Optional)',
};

export const FILE_ICONS = {
  jpg:'https://eu-images.contentstack.com/v3/assets/bltdd392fd32dda3ce8/blt56d6e81d602c99de/6797a371b19afb369b7afda0/File_Icon_JPG.svg',
  jpeg:'https://eu-images.contentstack.com/v3/assets/bltdd392fd32dda3ce8/blteca5e7feca91f3e6/6797a373b649e6acfd7702ab/File_Icon_JPEG.svg',
  pdf:'https://eu-images.contentstack.com/v3/assets/bltdd392fd32dda3ce8/blt28588d3724fd5c5f/6797a373786c5a20389b1511/File_Icon_PDF.svg',
  tif:'https://eu-images.contentstack.com/v3/assets/bltdd392fd32dda3ce8/blt3b6c0bce2454acfa/6797a3746c6824e35038a066/File_Icon_TIF.svg',
  tiff:'https://eu-images.contentstack.com/v3/assets/bltdd392fd32dda3ce8/blt4e38e3635afb2e77/6797a372274f954ab2ce7426/File_Icon_TIFF.svg',
  png:'https://eu-images.contentstack.com/v3/assets/bltdd392fd32dda3ce8/blt8595e906f89120f7/6797a372274f95371fce7428/File_Icon_PNG.svg'
};